import { ref } from 'vue'

const toastContainer = ref(null)

export function useCustomToast() {
  const setToastContainer = (container) => {
    toastContainer.value = container
  }

  const showToast = (type, message, options = {}) => {
    if (toastContainer.value) {
      return toastContainer.value.addToast({
        type,
        message,
        ...options
      })
    }
    
    // Fallback to global toast if container not available
    if (window.customToast) {
      return window.customToast[type](message, options)
    }
    
    console.warn('Toast container not initialized')
    return null
  }

  const success = (message, options = {}) => {
    return showToast('success', message, options)
  }

  const error = (message, options = {}) => {
    return showToast('error', message, options)
  }

  const info = (message, options = {}) => {
    return showToast('info', message, options)
  }

  const warning = (message, options = {}) => {
    return showToast('warning', message, options)
  }

  const preparing = (message, options = {}) => {
    return showToast('preparing', message, options)
  }

  const removeToast = (id) => {
    if (toastContainer.value) {
      toastContainer.value.removeToast(id)
    } else if (window.customToast) {
      window.customToast.remove(id)
    }
  }

  const clearAll = () => {
    if (toastContainer.value) {
      toastContainer.value.clearAll()
    } else if (window.customToast) {
      window.customToast.clear()
    }
  }

  return {
    setToastContainer,
    success,
    error,
    info,
    warning,
    preparing,
    removeToast,
    clearAll,
    showToast
  }
}
